module.exports = __webpack_public_path__ + "img/pr-2.d036735e.png";